"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="hero" className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542563/img/modern_office_sunlit_workspace.png)] overflow-hidden">
      {}
      <div className="absolute inset-0 bg-primary/10 pointer-events-none" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {}
        <h1 ref={headlineRef} className={`text-foreground font-bold mb-6 tracking-[-0.2px] transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Transform Your Business with Modern Cloud Solutions
        </h1>

        {}
        <p ref={textRef} className={`text-foreground text-lg leading-relaxed mb-10 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-150 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Streamline your operations, enhance collaboration, and unlock growth
          with our cutting-edge cloud accounting and business management
          platform.
        </p>

        {}
        <div ref={ctaRef} className={`flex flex-col items-center gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-300 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <Link to="/ServicesPage">
            <Button size="lg" className="rounded-[30px] px-8 py-4 text-base font-semibold shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-fast)] ease-out">
              Explore Our Services
            </Button>
          </Link>

          {}
          <Link to="/CloudAccountingPage" className="text-sm text-muted-foreground hover:text-foreground underline underline-offset-4 transition-colors duration-[var(--duration-fast)]">
            Learn more about Cloud Accounting
          </Link>
        </div>
      </div>
    </section>;
}